<!--
SPDX-FileCopyrightText: 2024 Comcast

SPDX-License-Identifier: LicenseRef-Comcast
-->

<ng-container *ngIf="getFilledInChunks() as filledInChunks">
  <div [innerHTML]="getInnerHtml(filledInChunks) | safeHtml"></div>
</ng-container>
